export const GRN_PENDING_ACTION = 'GRN_PENDING_ACTION'
export const GRN_PENDING_ACTION_SUCCESS = 'GRN_PENDING_ACTION_SUCCESS'
export const GRN_PENDING_ERROR_ACTION = 'GRN_PENDING_ERROR_ACTION'

